import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpResponse, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError, retry } from 'rxjs/operators';
import { AuthService } from './auth/auth.service';
import { environment } from '../../environments/environment.prod';
import { NotificacionesService } from './notificaciones.service';

@Injectable()

export class HttpConfigInterceptor implements HttpInterceptor {
    token: any;

    constructor(
        private authService: AuthService,
        private notiService: NotificacionesService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const url = request.url;
        const loginUrl = environment.wsUrl + 'login';
        const oauthCallbackUrl = environment.wsUrl + 'oauth/callback';
        const googleOauthUrl  = `https://accounts.google.com/o/oauth2/auth?client_id=974212845496-3uvdihjsq0q8l0ti3k157jn114ebtnjn.apps.googleusercontent.com&redirect_uri=${oauthCallbackUrl}&response_type=code&scope=openid%20email%20profile&state=0d4a3a2c-0a62-42db-b82f-032bd197b438`;
        const googleOauthUrl2 = `https://accounts.google.com/o/oauth2/auth?client_id=348145310019-af99004hb5d90tuf8b6r7vrv69tu96u8.apps.googleusercontent.com&redirect_uri=${oauthCallbackUrl}&response_type=code&scope=openid%20email%20profile&state=308dfd6f-f787-43e4-9ee6-9deaad9385b8`;
        // Determinar si es una petición a OCR (antes de todo)
        const isOcrRequest = url.includes('/webcontent-ocr/') || url.includes('webcontent-ocr');
        
        const valWS = url.includes(environment.wsUrl)
        if (valWS) this.notiService.cambiarEstatusLoader('Activar');
        this.token = localStorage.getItem('IES-AC-TK');
        
        if (!request.headers.has('Content-Type')) {
            request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
        }

        if (this.token && !url.includes('repse-qas.rotoplas.com.mx/login') && valWS && !url.includes('https://accounts.google.com/o/oauth2/auth?client_id=974212845496-3uvdihjsq0q8l0ti3k157jn114ebtnjn.apps.googleusercontent.com&redirect_uri=https://repse-qas.rotoplas.com.mx/oauth/callback&response_type=code&scope=openid%20email%20profile&state=0d4a3a2c-0a62-42db-b82f-032bd197b438')) {
            request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + this.token) });
        }

        // Agregar Authorization Bearer SOLO si NO es OCR y cumple otras condiciones
        if (!isOcrRequest && 
            this.token && 
            !url.includes(loginUrl) && 
            valWS && 
            !url.includes(googleOauthUrl) &&
            !url.includes(googleOauthUrl2)) {
            request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + this.token) });
        }
        
        // request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
        if (!url.includes('xccm/object/generarZip')) {
            // Sólo si no es la URL de generarZip, fuerza a JSON
            request = request.clone({
                headers: request.headers.set('Accept', 'application/json')
            });
        }
        
        // Si la petición es al OCR, agregar SOLO la API key y ELIMINAR Authorization si existe
        if (isOcrRequest) {
            const iesApiKey = 'kFmcYJjbsMbmy-Blw7NW9yIpJZN1QB4FlDd7ZMeqExA';
            
            // Eliminar el header Authorization si existe
            let headers = request.headers;
            if (headers.has('Authorization')) {
                headers = headers.delete('Authorization');
            }
            
            // Agregar el header IES-API-KEY
            headers = headers.set('IES-API-KEY', iesApiKey);
            
            // Clonar el request con los headers actualizados
            request = request.clone({ headers: headers });    
            // Verificar que Authorization no esté
            if (request.headers.has('Authorization')) {
                console.error('⚠️ ADVERTENCIA: Authorization todavía existe!');
            } else {
                console.log('✅ Confirmado: NO hay Authorization header');
            }
        }
        
        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    if (valWS) this.notiService.cambiarEstatusLoader('Desactivar');

                    // Ya no es necesario agregar el header aquí (es demasiado tarde);
                    // la clave se añade antes de enviar la petición.

                    if (url.includes(loginUrl)) {
                        console.log('Login===============================', event);
                        const dato = event.body.data;
                        localStorage.setItem('IES-AC-TK', dato['token']);
                        localStorage.setItem('IES-AC-RTK', dato['refreshToken']);
                    }
                    if (url.includes('/oauth/login')) {
                        console.log('OAuth Login===============================', event);
                        // OAuth login retorna una URL de redirección, no un token
                        // No hacer nada aquí, solo loguear
                        console.log('OAuth response body:', event.body);
                    }
                    else if (url.includes('/oauth/callback')) {
                        console.log('OAuth Callback===============================', event);
                        // El callback de OAuth es donde se recibe el token
                        if (event.body && event.body.data) {
                            const dato = event.body.data;
                            localStorage.setItem('IES-AC-TK', dato['token']);
                            localStorage.setItem('IES-AC-RTK', dato['refreshToken']);
                        } else if (event.body && event.body.token) {
                            // Si el token viene directamente en body
                            localStorage.setItem('IES-AC-TK', event.body.token);
                            if (event.body.refreshToken) {
                                localStorage.setItem('IES-AC-RTK', event.body.refreshToken);
                            }
                        } else {
                            console.log('OAuth callback response structure:', event.body);
                        }
                    }
                    else if (url.includes('/login') && !url.includes(loginUrl)) {
                        console.log('Login===============================', event);
                        const dato = event.body.data;
                        localStorage.setItem('IES-AC-TK', dato['token']);
                        localStorage.setItem('IES-AC-RTK', dato['refreshToken']);
                    }
                }
                return event;
            }),
            // Error
            catchError((error: HttpErrorResponse) => {
                if (valWS) this.notiService.cambiarEstatusLoader('Desactivar');
                if (!url.includes('/login')) {
                    if (error.status === 401) {
                        console.log('Error 401', error);
                    } else {
                        // this.store.dispatch(new MostrarMensajeErrorAction(`Error - ${error.status}`, 'Ocurrió un error'));
                    }
                } else {

                }
                return throwError(error);
            }));
    }
}
